<template>
	<div id="Button" class="Box BoxSmall" @click="_onPress" v-bind:class="{ Focus: focus, Active: active }">
		{{title}}
	</div>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import KeyListenerView from '../KeyListenerView';

	let visibleButtons = [];
	let focussedButton = 0;

	@Component({
		components: {
		},
	})
	export default class Button extends KeyListenerView {
		@Prop(String) title;
		@Prop(String) keyId;
		active = false;
        focus = false;

        mounted() {
        	this.addKeyboardListener('ENTER', this.onKeyEnter, 'Select');
        	this.addKeyboardListener('TAB', this.onKeyTab);
        	if(this.keyId)
        	    this.addKeyboardListener(this.keyId, this.onPress, this.title);
            visibleButtons.push(this);
        	this.focus = focussedButton === this._btnFocusIndex();
        	super.mounted();
    	}

    	_btnFocusIndex() {
        	return visibleButtons.indexOf(this);
    	}

    	destroyed() {
        	visibleButtons.splice(this._btnFocusIndex(),1);
        	super.destroyed();
    	}

        onKeyTab() {
            visibleButtons[focussedButton].focus = false;
            focussedButton = ++focussedButton % visibleButtons.length;
            visibleButtons[focussedButton].focus = true;
        }

        _onPress() {
            this.$emit('onPress');
        }

        onKeyEnter() {
        	clearTimeout(this.activeOnEnterTimeout)
        	this.active = true;
	        this.activeOnEnterTimeout = setTimeout(() => this.active = false, 150);
            setTimeout(() => visibleButtons[focussedButton].$emit('onPress'), 50);
        }
	}
</script>

<style lang="scss">
#Button {
	display: inline-block;
	margin-bottom: 2vmin;
	background: white;
}

#Button:focus,
#Button.Focus {
    background: #FDFD67;
}

#Button:active,
#Button.Active {
	top: 1vmin;
	left: 1vmin;
	background: #AA0000;
}
#Button:active:before,
#Button:active:after,
#Button.active:before,
#Button.active:after {
	display: none;
}
</style>